import React from 'react';

// TODO - migrate implementation from V2
const CookieApproval = () => (
    <div>give us cookies?</div>
);

export default CookieApproval;
